<template>
  <div class="v-text-field v-input pb-4">
    <div>
      <v-icon
        v-if="type === 'file'"
        class="mr-2 mt-2"
      >
        mdi-paperclip
      </v-icon>
    </div>
    <div>
      <div class="v-label v-label--active grey--text">
        {{ label }}
      </div>
      <div class="value">
        <template v-if="type === 'file'">
          <a
            class="text-decoration-none"
            :href="value.name || value"
            target="_blank"
          >
            {{ fileName }}
          </a>
        </template>
        <template v-else>
          {{ value || '—' }}
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getFileNameFromUrl } from '@/utils/vuex'

@Component
export default class BusinessDetailsField extends Vue {
  @Prop() label: string
  @Prop({ default: '—' }) value?: string|File
  @Prop({ default: 'text' }) type?: 'text'|'file'

  get fileName () {
    if (this.type !== 'file') return undefined
    if (!this.value) return '—'
    if (this.value instanceof File) return getFileNameFromUrl(this.value.name)
    return getFileNameFromUrl(this.value)
  }
}
</script>
<style lang="scss" scoped>
.v-label.v-label--active {
  transform: scale(0.75);
}
.value {
  line-height: 17px;
  white-space: pre-line;
}
</style>
